import { render, staticRenderFns } from "./xiaofei_mingxi.vue?vue&type=template&id=2a357a04"
import script from "./xiaofei_mingxi.vue?vue&type=script&lang=js"
export * from "./xiaofei_mingxi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports